import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageKO() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: AI 관계 분석 | 유해한 패턴 및 가스라이팅 감지" description="전 애인이 문제인지 확인하세요. ToxicDetector의 AI에 채팅을 업로드하여 조종, 가스라이팅 및 위험 신호를 즉각적이고 기밀로 분석합니다. 오늘 무료 스캔을 시작하세요." keywords="AI 관계 분석, 유해한 패턴 감지, 가스라이팅 감지기, 유해한 전 애인, 조종 확인, 관계 독성, AI 텍스트 스캐너" canonical="https://toxicdetector.com/ko" language="ko" alternateUrls={alternateUrls} data-id="element-8606" />
      <GoogleTranslateWidget data-id="element-8607" />
      <PromoBanner data-id="element-8608" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-8609">
        <Header data-id="element-8610" />
        <main data-id="element-8611">
          <HeroSection h1Override={<>
                당신의 뇌는{' '}
                <span className="relative inline-block" data-id="element-8613">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-8614">
                    거짓말
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-8615" />
                </span>{' '}
                을 하고 있습니다.
                <br data-id="element-8616" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-8617">
                  우리 AI는 아닙니다.
                </span>
              </>} data-id="element-8612" />
          <TrustSection data-id="element-8618" />
          <FeaturesSection data-id="element-8619" />
          <GuaranteesSection data-id="element-8620" />
          <ToolsSection data-id="element-8621" />
          <ComparisonSection data-id="element-8622" />
          <PricingSection data-id="element-8623" />
          <FAQSection data-id="element-8624" />
          <CTASection data-id="element-8625" />
        </main>
        <Footer data-id="element-8626" />
      </div>
    </>;
}